export const OfficeUserUpdate = {
	url: '/users/:id',
	title: 'Office Edit User',
	template: '<user-edit></user-edit>',
	params: {id: null},
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeUsersUpdatePageMod" */
			'@Containers/office-users-page/update/office-user-update.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
